import { render } from "./Blog5.vue?vue&type=template&id=647c75e2"
import script from "./Blog5.vue?vue&type=script&lang=js"
export * from "./Blog5.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__